function calcRoute(id) {
    try {
        // parse ID to ensure it's a number
        if(!Number.isInteger(id)){
            if(id.preventDefault) id.preventDefault();
            id = parseInt(id.target?.dataset?.id || id);
        }
        
        var from = null;
        var to = null;
        
        for(let i = 0; i < markersArray.length; i++){
            // Use loose equality to handle string/number IDs
            if(markersArray[i].id == id){
                to = markersArray[i];
            } else if(markersArray[i].id == 0){
                from = markersArray[i];
            }
        }
        
        if(!from || !to) {
            console.error('Cannot find markers:', {
                from: !!from,
                to: !!to,
                searchId: id,
                markers: markersArray.map(m => ({id: m.id, position: m.getPosition()}))
            });
            return;
        }
                
        // use DirectionsService (extracted as separate function for reusability)
        function useDirectionsService() {

            console.log('okinawa');
            
            var request = {
                origin: from.getPosition(),
                destination: to.getPosition(),
                travelMode: google.maps.TravelMode.DRIVING,
                unitSystem: google.maps.UnitSystem[SL_UNITS]
            };

            directionsService.route(request, function(result, status) {
                
                if (status == google.maps.DirectionsStatus.OK) {
                    directionsDisplay.setMap(boldMap);
                    directionsDisplay.setDirections(result);

                    if(!result.routes[0]?.legs.length) {
                        console.warn("Directions are missing instructions.");
                        return;
                    }

                    const steps = [];
                    result.routes[0].legs.forEach(leg => {
                        leg.steps?.forEach(step => {
                            steps.push({
                                instructions_txt: step.instructions,
                                distance_txt: step.distance.text
                            });
                        });
                    });

                    if(!steps.length) {
                        console.warn("Directions are missing steps:", result);
                        return;
                    }

                    renderDirectionsInstructions(to.store_address, steps);

                    for(let i=0; i<markersArray.length; i++){
                        markersArray[i].setMap(null);
                    }
                    infoPopup.setMap(null);
                    
                }
            });
        }
        
        // Main routing logic with fallback
        if(from && to){
            if(SL_USE_ROUTES_API) {
                
                const origin = {
                    location: {
                        latLng: {
                            latitude: from.getPosition().lat(),
                            longitude: from.getPosition().lng()
                        }
                    }
                }

                const destination = {
                    location: {
                        latLng: {
                            latitude: to.getPosition().lat(),
                            longitude: to.getPosition().lng()
                        }
                    }
                }

                getDirectionsViaRoutesApi(origin, destination, SL_UNITS)
                    .then(directions => {
                        console.log('Routes API response:', directions);
                        
                        if(directions.routes[0]?.legs?.length) {
                            const steps = [];

                            directions.routes[0].legs.forEach(leg => {
                                leg.steps?.forEach(step => {
                                    steps.push({
                                        instructions_txt: step.navigationInstruction.instructions,
                                        distance_txt: step.localizedValues.distance.text
                                    });
                                });
                            });

                            if(!steps.length) {
                                console.warn("Directions are missing steps, falling back...");
                                useDirectionsService();
                                return;
                            }

                            renderDirectionsInstructions(to.store_address, steps);

                            const PolylinePath = google.maps.geometry.encoding.decodePath(directions.routes[0].polyline.encodedPolyline);
                            SLRoutePolyline.setPath(PolylinePath);

                            // Hide all markers except our origin and destination markers
                            markersArray.forEach(marker => {
                                if(marker.id != id && marker.id != 0) {
                                    marker.setMap(null);
                                }
                            });

                            if(!SLRoutePolyline.getMap()) SLRoutePolyline.setMap(boldMap);

                            infoPopup.setMap(null);
                            
                        } else {
                            console.warn("Routes API returned invalid structure, falling back...");
                            useDirectionsService();
                        }
                    })
                    .catch(error => {
                        console.warn('⚠️ Routes API failed, falling back to DirectionsService:', error);
                        useDirectionsService();
                    });
            } else {
                // Routes API disabled, use DirectionsService directly
                useDirectionsService();
            }
        }
        
    } catch(error) {
        console.error('Error in calcRoute:', error);
    }
}
